import { memo } from 'react'

import IMask from 'imask'
import { Validators } from 'ui/components/Form'

import { BaseMaskedInput } from './BaseMaskedInput'
import { PercentInputProps } from './props'
import { InputIconPosition } from './types'

const PERCENT_MIN = 0
const PERCENT_MAX = 100
const PERCENT_SYMBOL = '%'

export const PercentInput = memo((props: PercentInputProps) => {
  const { scale = 2 } = props

  const mask = IMask.createMask({
    mask: Number,
    scale,
    radix: '.'
  })

  return (
    <BaseMaskedInput
      {...props}
      mask={mask}
      validator={Validators.number.between(PERCENT_MIN, PERCENT_MAX)}
      renderIcon={PERCENT_SYMBOL}
      iconPosition={InputIconPosition.RIGHT_CLOSE}
    />
  )
})
